(function () {
  const storageKey = 'aprilArtStudio:favorites:v1';

  function getFavorites() {
    try {
      const parsed = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_error) {
      return [];
    }
  }

  function setFavorites(items) {
    window.localStorage.setItem(storageKey, JSON.stringify(items));
    window.dispatchEvent(new CustomEvent('april:favorites:updated', { detail: { items } }));
  }

  function getItemFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice,
      variantId: button.dataset.productVariantId,
    };
  }

  function isFavorited(id) {
    return getFavorites().some((item) => item.id === id);
  }

  function updateButton(button) {
    const active = isFavorited(button.dataset.productId);
    button.classList.toggle('is-favorited', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      `${active ? 'Remove' : 'Add'} ${button.dataset.productTitle || 'product'} ${active ? 'from' : 'to'} favorites`
    );
  }

  function bindButtons(root = document) {
    root.querySelectorAll('[data-april-favorite-button]').forEach((button) => {
      if (button.dataset.aprilFavoriteBound === 'true') {
        updateButton(button);
        return;
      }

      button.dataset.aprilFavoriteBound = 'true';
      updateButton(button);

      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const item = getItemFromButton(button);
        if (!item.id) return;

        const favorites = getFavorites();
        const exists = favorites.some((favorite) => favorite.id === item.id);
        const nextFavorites = exists
          ? favorites.filter((favorite) => favorite.id !== item.id)
          : [item, ...favorites.filter((favorite) => favorite.id !== item.id)];

        setFavorites(nextFavorites);
        updateAllButtons();
        renderFavoritesPage();
      });
    });
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-april-favorite-button]').forEach(updateButton);
  }

  function moneyFromProduct(product) {
    if (!product || typeof product.price !== 'number') return '';
    return `$${(product.price / 100).toFixed(2)}`;
  }

  async function refreshFavorite(item) {
    if (!item.handle) return item;

    try {
      const response = await fetch(`/products/${item.handle}.js`, { credentials: 'same-origin' });
      if (!response.ok) return item;

      const product = await response.json();
      return {
        ...item,
        title: product.title || item.title,
        url: product.url || item.url,
        image: product.featured_image || item.image,
        price: moneyFromProduct(product) || item.price,
        variantId: product.variants?.[0]?.id || item.variantId,
      };
    } catch (_error) {
      return item;
    }
  }

  function favoriteCard(item) {
    const safeTitle = item.title || 'Saved product';
    const image = item.image
      ? `<img src="${item.image}" alt="${safeTitle.replace(/"/g, '&quot;')}" loading="lazy">`
      : '<div class="april-favorites-page__placeholder" aria-hidden="true"></div>';

    return `
      <article class="april-favorites-page__card" data-favorite-card-id="${item.id}">
        <a class="april-favorites-page__media" href="${item.url || '#'}">${image}</a>
        <div class="april-favorites-page__card-body">
          <a class="april-favorites-page__title" href="${item.url || '#'}">${safeTitle}</a>
          ${item.price ? `<span class="april-favorites-page__price">${item.price}</span>` : ''}
          <div class="april-favorites-page__actions">
            <a class="april-favorites-page__view" href="${item.url || '#'}">View product</a>
            <button type="button" class="april-favorites-page__remove" data-april-remove-favorite="${item.id}">Remove</button>
          </div>
        </div>
      </article>
    `;
  }

  async function renderFavoritesPage() {
    if (window.location.pathname.replace(/\/$/, '') !== '/pages/favorites') return;

    const main = document.getElementById('MainContent');
    if (!main) return;

    document.body.classList.add('april-favorites-route');
    document.title = "Favorites - April's Art Studio";

    const favorites = getFavorites();
    const refreshed = await Promise.all(favorites.map(refreshFavorite));

    if (JSON.stringify(refreshed) !== JSON.stringify(favorites)) {
      setFavorites(refreshed);
    }

    let grid = main.querySelector('[data-april-favorites-grid]');
    let emptyState = main.querySelector('[data-april-favorites-empty]');

    if (!grid || !emptyState) {
      main.innerHTML = `
        <section class="april-favorites-page" data-april-favorites-page>
          <div class="april-favorites-page__inner">
            <h1>Favorites</h1>
            <p class="april-favorites-page__intro">
              Keep track of the pieces and products you love, then come back when you are ready to shop.
            </p>
            <div class="april-favorites-page__grid" data-april-favorites-grid hidden></div>
            <div class="april-favorites-page__empty" data-april-favorites-empty>
              <h2>Your favorites list is waiting.</h2>
              <p>Tap the heart on any product card to save it here.</p>
              <a href="/collections/all" class="april-favorites-page__view">Browse products</a>
            </div>
          </div>
        </section>
      `;
      grid = main.querySelector('[data-april-favorites-grid]');
      emptyState = main.querySelector('[data-april-favorites-empty]');
    }

    grid.innerHTML = refreshed.map(favoriteCard).join('');
    grid.hidden = refreshed.length === 0;
    emptyState.hidden = refreshed.length > 0;

    grid.querySelectorAll('[data-april-remove-favorite]').forEach((button) => {
      button.addEventListener('click', () => {
        setFavorites(getFavorites().filter((item) => item.id !== button.dataset.aprilRemoveFavorite));
        updateAllButtons();
        renderFavoritesPage();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindButtons();
    renderFavoritesPage();
  });

  document.addEventListener('shopify:section:load', (event) => {
    bindButtons(event.target);
  });

  window.addEventListener('april:favorites:updated', updateAllButtons);
})();
